<template>
  <div>
    <span v-for="(p, idx) in parts" :key="idx">
      <span :class="getClass(idx)">{{p}}</span><span v-if="idx + 1 < parts.length"> + </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'QualifiedPattern',
  props: {
    pattern: {
      type: String,
      required: true
    },
    coreIndexes: {
      type: Array,
      default: function () { return [] }
    }
  },
  computed: {
    parts: function () {
      return this.pattern.split(' + ')
    }
  },
  methods: {
    getClass: function (idx) {
      return this.coreIndexes.includes(idx) ? 'core' : 'coll'
    }
  }
}
</script>

<style scoped>
  .coll {
    font-weight: bold
  }
</style>
